// @flow

export { default as placeWidgetHook } from '../../../libs/place-widget-hook';

export default {};
